export default "__VITE_ASSET__9f822bd0__"